import React from 'react'
import { useTrans } from 'hooks'
import { PaginaNode } from '@gql/graphql'
import { PlaceholderReact } from '@components/molecules'
import { ListingHead, Page } from 'components/organisms'
import styles from './AcquistiOnlineHubTemplate.module.sass'

interface Props {
  pagina?: PaginaNode
  mainContent?: any
}

const AcquistiOnlineHubTemplate = (props: Props) => {
  const { pagina = undefined, mainContent = undefined } = props

  const t = useTrans()

  return (
    <Page pagina={pagina} className={`${styles.root}`}>
      <main>
        <ListingHead pagina={pagina} />
        <div className={styles.main}>
          <PlaceholderReact
            contentTypeId={pagina.model}
            objectId={pagina.pk}
            pkey={'main'}
            serverSideContent={mainContent}
          />
        </div>
      </main>
    </Page>
  )
}

export default AcquistiOnlineHubTemplate
